import Select from "react-select";
import React, { useRef, useState, useEffect } from "react";
import { _defaultBooking } from "./index";
import { db } from "../../index";
import { useCompanyOptions } from "../company";
import { OutlineButton } from "../../components/layout/OutlineButton";

export default function FormDriver({
  userInfos,
  isLoaded,
  booking,
  setBookingField,
}) {
  const driverSelect = useRef(null);
  const companySelect = useRef(null);
  const companyOptions = useCompanyOptions();
  const [driverOptions, setDriverOptions] = useState([]);

  // Clear selects when driver is reset (e.g., when vehicle changes)
  useEffect(() => {
    if (!booking.driver?.id) {
      if (companySelect.current?.select) {
        companySelect.current.select.clearValue();
      }
      if (driverSelect.current?.select) {
        driverSelect.current.select.clearValue();
      }
      setDriverOptions([]);
    }
  }, [booking.driver?.id]);

  function handleCompanyChange(company) {
    if (!company) return;

    setBookingField("driver", _defaultBooking.driver);
    setDriverOptions([]);

    if (driverSelect.current?.select) {
      driverSelect.current.select.clearValue();
    }
    // Note: companySelect doesn't need to be cleared here as we're setting a new company

    let _driverOptions = [];
    db.ref("users/" + userInfos.uid + "/driver")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach(function (childSnapshot) {
            if (childSnapshot.val().company.id === company.value) {
              _driverOptions.push({
                value: childSnapshot.key,
                label: childSnapshot.val().name,
                data: {
                  ...childSnapshot.val(),
                  company: company.data,
                  id: childSnapshot.key,
                },
              });
            }
          });

          setDriverOptions(_driverOptions);
        }
      });
  }

  function handleClearDriver() {
    setBookingField("driver", _defaultBooking.driver);
    if (driverSelect.current?.select) {
      driverSelect.current.select.clearValue();
    }
    if (companySelect.current?.select) {
      companySelect.current.select.clearValue();
    }
    setDriverOptions([]);
  }

  if (!isLoaded)
    return (
      <div className="kt-section kt-section--first">
        <p>Chargement...</p>
      </div>
    );
  return (
    <div className="kt-section kt-section--first">
      <div className="kt-section__body">
        <div className="form-group row">
          <label className="col-lg-3 col-form-label">Compagnie</label>
          <div className="col-lg-6">
            <Select
              ref={companySelect}
              options={companyOptions}
              onChange={handleCompanyChange}
              isDisabled={booking.sharedBy}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-lg-3 col-form-label">Chauffeur</label>
          <div className="col-lg-6">
            <Select
              ref={driverSelect}
              options={driverOptions}
              onChange={(obj) =>
                setBookingField("driver", obj?.data || _defaultBooking.driver)
              }
              isDisabled={booking.sharedBy}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-lg-3 col-form-label">Nom:</label>
          <div className="col-lg-6">
            <input
              type="text"
              className="form-control"
              value={booking.driver?.name}
              name="driver_name"
              disabled
            />
            {booking.driver?.id ? (
              <div className="input-group-append">
                <OutlineButton
                  className="mt-1"
                  type="button"
                  onClick={handleClearDriver}
                  disabled={booking.sharedBy}
                >
                  Retirer le chauffeur
                </OutlineButton>
              </div>
            ) : null}
          </div>
        </div>
        <div className="form-group row">
          <label className="col-lg-3 col-form-label">Téléphone:</label>
          <div className="col-lg-6">
            <input
              type="text"
              className="form-control"
              value={booking.driver?.phone}
              name="driver_phone"
              disabled
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-lg-3 col-form-label">Compagnie:</label>
          <div className="col-lg-6">
            <input
              type="tel"
              className="form-control"
              value={booking.driver?.company?.name}
              name="driver_company"
              disabled
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-lg-3 col-form-label">Numéro Macaron :</label>
          <div className="col-lg-6">
            <input
              type="number"
              className="form-control"
              name="driver.macaron_number"
              value={booking.driver?.macaron_number}
              onChange={(e) =>
                setBookingField("driver.macaron_number", e.target.value)
              }
              disabled={booking.sharedBy}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
